import { useRef } from "react";
import { Typography, Box, Button } from "@mui/material";
import { getLayoutLine } from "../../../components/layout/getLayoutLine";
import { postDownload } from "../../../fetch/postDownload";
export function Developer(props) {
  const { panel: __panel__ } = props;
  const __ref__ = useRef(null);
  return (
    <Box className="pk__page">
      <Box className="pk__block">
        <Box className="pk__info">
          <Typography variant="caption" color="secondary.dark">
            Last updated July, 22 2026
          </Typography>
          <Button
            className="link"
            component="a"
            onClick={() =>
              postDownload("polycaik_developer_agreement.pdf", __ref__.current)
            }
          >
            Download (PDF)
          </Button>
        </Box>
        <Typography variant="h4" color="#606060" paddingTop={5}>
          <strong>Polycaik Game Development Agreement</strong>
        </Typography>
        <Typography variant="h6" color="#007eff">
          <button className="link" onClick={() => __panel__("__platform__")}>
            Schedule A To Platform Agreement
          </button>
        </Typography>
        <Box className="pk__body" ref={__ref__}>
          {getLayoutLine([
            <>
              This Polycaik Game Development Agreement (the “
              <span className="token">Development Agreement</span>”) is between
              (i) a Participant posting Game Content on the Polycaik Platform
              under the Platform Agreement (“
              <span className="token">Contributor</span>”) and (ii) a
              Participant using Contributor’s Game Content, under the Platform
              Agreement, to develop Games (“
              <span className="token">Developer</span>”) (each a “
              <span className="token">Party</span>” and together the “
              <span className="token">Parties</span>”).
            </>,
            <>
              <span className="token header caution">WHEREAS,</span> Contributor
              has developed, created, and uploaded onto the Polycaik Platform,
              Game Content;
            </>,
            <>
              <span className="token header caution">WHEREAS,</span> Developer
              wishes to use and incorporate such Game Content into one or more
              Games, and Contributor is willing to allow such use, all in
              accordance with the terms and conditions set out below;
            </>,
            <>
              <span className="token header caution">NOW, THEREFORE,</span> in
              consideration of the mutual promises set forth in this Development
              Agreement, the Parties, intending to be legally bound, agree as
              follows:
            </>,
          ])}
          <Box className="stub stub--title">
            <span className="token token--slot">1.</span>
            <div>
              <span className="token header">Acceptance of Terms.</span>By
              clicking “I accept” to the Platform Agreement, each Party accepts
              and agrees to be bound by the terms and conditions set out in this
              Gamer Development Agreement. If a Party does not agree to these
              terms and conditions, that Party must not post, access, or use
              Game Content via the Platform.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token token--slot">2.</span>
            <div>
              <span className="token header">Definitions.</span>Capitalized
              terms have the meaning set forth in context below or in{" "}
              <button
                className="link"
                onClick={() => __panel__("__glossary__")}
              >
                Uniform Definitions
              </button>
              .
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token token--slot">3.</span>
            <div>
              <span className="token header">
                Acknowledgment of Platform Agreement.
              </span>
              Each Party acknowledges (i) that it has separately entered into
              the Platform Agreement with Polycaik and is bound by its terms;
              and (ii) that this Development Agreement creates rights and
              obligations between Developer and Gamer separate from the Platform
              Agreement.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token token--slot">4.</span>
            <span className="token header">
              Intellectual Property and Licensing.
            </span>
          </Box>
          <Box className="stub">
            <span className="token token--slot">4.1.</span>
            <div>
              <span className="token header">
                Grant of Rights to Developer.
              </span>
              Contributor hereby grants to Developer, under Contributor’s
              Intellectual Property Rights and during and after the Term, a
              limited, non-exclusive, non-transferable license (i) to access,
              use, and incorporate Contributor’s Game Content in Developer’s
              Games; and (ii) to display and distribute such Games via the
              Platform for Gamers’ use.
            </div>
          </Box>
          <Box className="stub">
            <span className="token token--slot">4.2.</span>
            <div>
              <span className="token header">
                No Developer Modifications to Game Content.
              </span>
              Other than minor modifications required to integrate Contributor’s
              Game Content into Developer’s Game, Developer is prohibited from
              modifying or changing Contributor’s Game Content.
            </div>
          </Box>
          <Box className="stub">
            <span className="token token--slot">4.3.</span>
            <div>
              <span className="token header">Limitation to Platform.</span>
              Developer is prohibited from using Contributor’s Game Content
              outside the Platform.
            </div>
          </Box>
          <Box className="stub">
            <span className="token token--slot">4.4.</span>
            <div>
              <span className="token header">Restrictions.</span>Developer shall
              not, and shall not permit any third party to: (a) reverse
              engineer, decompile, disassemble, or otherwise attempt to derive
              the source code or underlying algorithms of any Contributor’s Game
              Content or Game Elements; (b) modify, adapt, translate, or create
              derivative works based on any Contributor’s Game Content, except
              as expressly permitted by the Platform or Section 4.2 (No
              Developer Modifications to Game Content); (c) copy, distribute,
              sublicense, rent, lease, or lend any Contributor’s Game Content or
              any portion thereof; (d) remove, alter, or obscure any proprietary
              notices, labels, or marks on or in any Contributor’s Game Content;
              or (e) use any Contributor’s Game Content for any unlawful
              purpose. Any use of Contributor’s Game Content beyond the scope of
              the license granted in Section 4.1 (Grant of Rights to Developer)
              will constitute a material breach of this Development Agreement.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token token--slot">5.</span>
            <div>
              <span className="token header">Compensation.</span>Developer will
              compensate Contributor for Developer’s use of Contributor’s Game
              Content, all in accordance with the Platform Agreement.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token token--slot">6.</span>
            <div>
              <span className="token header">
                Contributor’s Representations and Warranties.
              </span>
              Contributor represents and warrants to the Developer that: (i) its
              Game Content does not infringe the Intellectual Property Rights of
              any third party; (ii) its Game Content does not contain any
              viruses, malware, or other harmful code; and (iii) it will comply
              with applicable law.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token token--slot">7.</span>
            <div>
              <span className="token header">
                Developer’s Representations and Warranties.
              </span>
              Developer represents and warrants to Contributor that: (i)
              Developer’s Games, (excluding any of Contributor’s Game Content),
              do not infringe the Intellectual Property Rights of third parties;
              (ii) Developer’s Games do not contain any viruses, malware, or
              other harmful code; and (iii) Developer will comply with
              applicable law.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token token--slot">8.</span>
            <span className="token header">Indemnification.</span>
          </Box>
          <Box className="stub">
            <span className="token token--slot">8.1.</span>
            <div>
              <span className="token header">Contributor Indemnification.</span>
              Contributor shall indemnify, defend, and hold harmless Developer
              from and against any and all third-party claims, damages, losses,
              liabilities, costs, and expenses (including reasonable attorneys'
              fees) arising out of or related to a violation or misappropriation
              of such third party’s Intellectual Property Rights by
              Contributor’s Game Content.
            </div>
          </Box>
          <Box className="stub">
            <span className="token token--slot">8.2.</span>
            <div>
              <span className="token header">Developer Indemnification.</span>
              Developer shall indemnify, defend, and hold harmless Contributor
              from and against any and all third party claims, damages, losses,
              liabilities, costs, and expenses (including reasonable attorneys’
              fees) arising out of or related to a violation or misappropriation
              of such third party’s Intellectual Property Rights by Developer’s
              Games (excepting any Game Content from Contributor) that rely on
              Contributor’s Game Content.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token token--slot">9.</span>
            <div>
              <span className="token header">Data Handling and Privacy.</span>
              The Polycaik Privacy Policy governs the collection and treatment
              of Personal Information.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token">10.</span>
            <div>
              <span className="token header">Limitation of Liability.</span>
              <span className="caution">
                EXCEPT WITH RESPECT TO CONTRIBUTOR’S INDEMNIFICATION OBLIGATIONS
                UNDER SECTION 8.1
              </span>{" "}
              (Contributor Indemnification){" "}
              <span className="caution">
                AND DEVELOPER’S INDEMNIFICATION OBLIGATIONS UNDER SECTION 8.2
              </span>{" "}
              (Developer Indemnification),{" "}
              <span className="caution">
                ONE PARTIES’ TOTAL AGGREGATE LIABILITY TO THE OTHER PARTY UNDER
                THIS DEVELOPMENT AGREEMENT SHALL NOT EXCEED THE TOTAL AMOUNT
                FEES DEVELOPER HAS PAID OR OWES UNDER THE PLATFORM AGREEMENT. IN
                NO EVENT SHALL EITHER PARTY BE LIABLE FOR ANY INDIRECT, SPECIAL,
                INCIDENTAL, PUNITIVE, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                ARISING OUT OF OR RELATED TO THIS AGREEMENT.
              </span>
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token">11.</span>
            <div>
              <span className="token header">Term.</span>
              This Game Development Agreement shall commence once both
              Contributor and Developer have entered into the Platform Agreement
              and, unless earlier terminated pursuant to Section 12
              (Termination), shall continue for the period specified in the
              applicable Access Plan (the “<span className="token">Term</span>
              ”).
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token">12.</span>
            <span className="token header">Termination.</span>
          </Box>
          <Box className="stub">
            <span className="token">12.1.</span>
            <div>
              <span className="token header">
                Termination for Material Breach.
              </span>
              Either Party may terminate this Development Agreement upon written
              notice if the other Party materially breaches this Development
              Agreement and fails to cure such breach within thirty (30) days
              after receipt of written notice thereof.
            </div>
          </Box>
          <Box className="stub">
            <span className="token">12.2.</span>
            <div>
              <span className="token header">
                Termination by Developer for Convenience.
              </span>
              Developer may terminate this Development Agreement for convenience
              upon ten (10) days’ prior written notice to Contributor or by
              ceasing to use Contributor’s Game Content. Developer will be
              responsible for any outstanding payment obligations accrued prior
              to the effective date of termination.
            </div>
          </Box>
          <Box className="stub">
            <span className="token">12.3.</span>
            <div>
              <span className="token header">
                Termination by Contributor for Convenience.
              </span>
              Contributor may terminate this Development Agreement for
              convenience upon ten (10) days’ prior written notice to Developer,
              subject to the continuing rights set forth in Section 12.5 (Game
              Continuity and Continuing Rights).
            </div>
          </Box>
          <Box className="stub">
            <span className="token">12.4.</span>
            <div>
              <span className="token header">Effect of Termination.</span>Upon
              termination or expiration of this Development Agreement, no
              further licensing of the Contributor's Game Content shall be
              permitted.
            </div>
          </Box>
          <Box className="stub">
            <span className="token">12.5.</span>
            <div>
              <span className="token header">
                Game Continuity and Continuing Rights.
              </span>
              If Contributor, as of the termination or expiration of this
              Development Agreement, has submitted Game Content to the Platform
              (“
              <span className="token">Existing Content</span>”), and if
              Developer has purchased the Existing Content in one or more of
              Developer’s Games as of such termination or expiration (each an “
              <span className="token">Existing Game</span>”), then Participant
              agrees that Developer’s license under Section 4.1 (Grant of Rights
              to Developer) shall remain in full force and effect after
              termination or expiration of this Development Agreement and shall
              continue for so long as Developer offers the Existing Game and
              later editions of such Game.
            </div>
          </Box>
          <Box className="stub">
            <span className="token">12.6.</span>
            <div>
              <span className="token header">Platform Agreement.</span>
              The termination of this Development Agreement does not
              automatically terminate the Platform Agreement. If a Party desires
              to terminate its Platform Agreement, it should do so under the
              terms of the Platform Agreement. Conversely, termination of the
              Platform Agreement shall automatically terminate this Development
              Agreement.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token">13.</span>
            <span className="token header">General Provisions.</span>
          </Box>
          <Box className="stub">
            <span className="token">13.1.</span>
            <div>
              <span className="token header">Governing Law.</span>This
              Development Agreement shall be governed by and construed in
              accordance with the laws of the State of New Jersey.
            </div>
          </Box>
          <Box className="stub">
            <span className="token">13.2.</span>
            <span className="token header">Dispute Resolution.</span>
          </Box>
          <Box className="stub" flexDirection="column" paddingBottom={0}>
            <Box className="stub">
              <span className="token">13.2.1.</span>
              <div>
                <span className="token header">Binding Arbitration.</span>Any
                controversy or claim arising out of or relating to this
                Development Agreement shall be resolved by confidential
                arbitration conducted in Passaic County, New Jersey, and
                administered by JAMS in accordance with its applicable rules.
                The JAMS rules for selection of an arbitrator shall be followed,
                except that the arbitrator shall be a former judge. Upon
                conclusion of any arbitration proceedings hereunder, the
                arbitrator shall render findings of fact and conclusions of law
                and a written opinion setting forth the basis and reasons for
                any decision the arbitrator has reached and shall deliver such
                documents to each Party to this Development Agreement along with
                a signed copy of the award in accordance with applicable JAMS
                rules.
              </div>
            </Box>
            <Box className="stub">
              <span className="token">13.2.2.</span>
              <div>
                <span className="token header">
                  Enforcement; Jurisdiction; Arbitration Remedies.
                </span>
                Any judgment upon the award rendered by the arbitrator may be
                entered in any state or federal court that has requisite subject
                matter jurisdiction and that sits in the judicial district that
                includes Passaic County, New Jersey and the Parties agree to
                submit to the in personam jurisdiction of such courts for
                purposes of confirming any such award and entering judgment
                thereon. The arbitrator shall have the authority to grant any
                equitable and legal remedies that would be available in any
                judicial proceeding instituted to resolve a disputed matter,
                subject to any waivers of such remedies made by any Party in
                this Development Agreement. The Parties hereto waive any and all
                objections that they may have as to jurisdiction or venue in any
                of the above courts.
              </div>
            </Box>
          </Box>
          <Box className="stub">
            <span className="token">13.3.</span>
            <div>
              <span className="token header">No Waiver; Entire Agreement.</span>
              Neither Party will be treated as having waived any rights by not
              exercising (or delaying the exercise of) any rights under this
              Development Agreement. This Development Agreement states all terms
              agreed between the Parties and cancels and replaces all other
              agreements between the Parties relating to its subject matter. If
              any term (or part of a term) of this Development Agreement is
              invalid, illegal, or unenforceable, the rest of the Agreement will
              remain in effect.
            </div>
          </Box>
          <Box className="stub">
            <span className="token">13.4.</span>
            <div>
              <span className="token header">Remedies.</span>
              Unless otherwise provided in this Development Agreement, no remedy
              is exclusive, and a Party shall be entitled to assert all
              available rights and remedies.
            </div>
          </Box>
          <Box className="stub">
            <span className="token">13.5.</span>
            <div>
              <span className="token header">Force Majeure.</span>
              Neither Party shall be liable for a failure or delay in the
              performance of its obligations under this Development Agreement
              due to strikes (except with respect to its own labor force),
              shortages, riots, pandemic, insurrection, acts of God, war,
              governmental action, power or connectivity interruptions, or other
              causes beyond the reasonable control of such Party.
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
